import React, { FC } from 'react';
import styled from 'styled-components';
import { Colors } from '../../../styles/colors';
import * as Text from '../Text';
import { Flexbox } from '../Layout';
import { Checkbox } from '../forms/Checkbox';

const FilterBlockItem = styled.div`
	background-color: ${Colors.white};
	padding: 1.5rem;
	color: ${Colors.grayDark};
	margin-top: 1.5rem;
`;

const FilterHeadlineAccent = styled(Text.Headline5)<{ active: boolean }>`
	color: ${({ active = true }) => active ? Colors.primary : Colors.grayDark};
	font-weight: ${({ active = true }) => active ? 700 : 400};
`;

const FilterHeadlineWrapper = styled(Flexbox)<{ clickable: boolean }>`
	margin-top: 1.5rem;
	cursor: ${({ clickable = false }) => clickable ? 'pointer' : 'default'};
	pointer-events: ${({ clickable = false }) => clickable ? 'auto' : 'none'};
	
	${FilterHeadlineAccent} {
	  margin-left: .5rem;
	}
`;

interface FilterItem {
  title: string;
  onClick?: () => void;
  active?: boolean;
  checked?: boolean;
}

interface Props {
  title: string;
  items: FilterItem[];
}

export const FilterGroup: FC<Props> = ({ title, items }) => {
  return (
    <FilterBlockItem>
      <Text.Headline6>{title}:</Text.Headline6>
      {
        items.map((item, index) => (
          <FilterHeadlineWrapper clickable={item.onClick !== undefined && item.active}>
            <Checkbox checked={item.checked} disabled={!item.active} id={`${title}-${index}`} onChange={(checked) => {
              if (item.onClick) {
                item.onClick();
              }
            }} />
            <FilterHeadlineAccent
              key={index}
              active={item.active}
              onClick={item.onClick}
            >
              {item.title}
            </FilterHeadlineAccent>
          </FilterHeadlineWrapper>
        ))
      }
    </FilterBlockItem>
  );
};
